export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as townsKey, initialState as townsInitialState, State as TownsState } from './reducer';

export {
  getData as townsGetData,
  getError as townsGetError,
  getLoading as townsGetLoading,
  mapData as townsMapData,
} from './selectors';
